import React, { useEffect } from 'react'
import CategoryCard from '../component/CategoryCard'

const LandingPage = () => {

    const handleRemove = () => {
        sessionStorage.setItem("story_id");
        sessionStorage.removeItem("formType")
        
      };
      useEffect(()=>{
        sessionStorage.removeItem("story_id");
        sessionStorage.removeItem("formType")
      },[])
    return (
        <div className='items-stretch flex gap-2 absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] w-full justify-center items-center px-5'>
            <CategoryCard

             onclickk={handleRemove}

             
                id="story"
                title="Story"
                icon="./assets/images/story-c.png"
                border="#EE635B"
                bgcolor="#FFE6D9"
            />

            <CategoryCard
                id="blogs"
                title="Blogs"
                icon="./assets/images/blog-c.png"
                border="#EAB14D"
                bgcolor="#FFF7C1"
            />

            <CategoryCard
                id="press"
                title="Press Release"
                icon="./assets/images/press-c.png"
                border="#595CFF"
                bgcolor="#E5EDFF"
            />
        </div>
    )
}

export default LandingPage
